import getStore from '../store';

export function getNoteColor(remoteId: string) {
    return getStore().notes.get(remoteId)?.color ?? '';
}
